<!-- DeleteMemberAccountForm.vue -->
<script setup>
import { ref, computed, watch } from "vue";
import { useManagedAccountStore } from "@/stores/useManagedAccountStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  relationship: { type: Object, required: true },
});

const emit = defineEmits(["close", "refresh", "notify"]);
const managedAccountStore = useManagedAccountStore();

// Congela os dados exibidos para a mensagem não mudar após o clique
const frozenFullName = ref("");
const frozenUserName = ref("");

function freeze() {
  frozenFullName.value = props.relationship?.fullName?.trim?.() || "";
  frozenUserName.value = props.relationship?.userName?.trim?.() || "";
}

watch(
  () => [props.relationship?.fullName, props.relationship?.userName],
  () => freeze(),
  { immediate: true },
);

const title = "Apagar/Revogar Vínculo";

const messageTitle = computed(() => {
  const fullName = frozenFullName.value;
  const userName = frozenUserName.value;

  if (fullName && userName) {
    return `Você está prestes a apagar/revogar o vínculo da conta membro "${fullName}" (@${userName}).`;
  }

  if (fullName) {
    return `Você está prestes a apagar/revogar o vínculo da conta membro "${fullName}".`;
  }

  if (userName) {
    return `Você está prestes a apagar/revogar o vínculo da conta membro "@${userName}".`;
  }

  return "Você está prestes a apagar/revogar este vínculo.";
});

const messageSubtitle = "Esta ação não pode ser desfeita.";

function buildErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao apagar/revogar o vínculo."
  );
}

async function onConfirm() {
  freeze();

  try {
    await managedAccountStore.revokeRelationship(
      props.relationship.managedAccountRelationshipId,
    );

    emit("notify", {
      type: "success",
      message: "Vínculo apagado/revogado com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildErrorMessage(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    :title="title"
    :messageTitle="messageTitle"
    :messageSubtitle="messageSubtitle"
    confirmText="Sim, apagar/revogar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirm"
    @close="emit('close')"
  />
</template>
